import script from "./FinanceDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceDashboard.vue?vue&type=script&setup=true&lang=js"

import "./FinanceDashboard.vue?vue&type=style&index=0&id=aae40004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aae40004"]])

export default __exports__